import React, { useEffect, useState, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  LoadScript,
} from "@react-google-maps/api";
import axiosConfig from "../../../Service/AxiosConfig";
import "./address.css";
import { useDispatch } from "react-redux";
import { updateTempForm } from "../../../redux/BookingFormSlice";

const librariesArray = ["places"];
const AddressModal = ({
  isOpen,
  onClose,
  formData,
  setFormData,
  address_id,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [addressId, setAddressId] = useState(address_id || null);
  const [apiKey, setApiKey] = useState("");
  const mapRef = useRef(null);
  const placesServiceRef = useRef(null);
  const debounceTimer = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    axiosConfig
      .get("/masters/googlemapkey/")
      .then((res) => setApiKey(res?.data?.results[0].key));
  }, []);
  useEffect(() => {
    if (!isOpen || !apiKey) return;
    if (formData.latitude && formData.longitude) {
      setSelectedLocation({
        lat: formData.latitude,
        lng: formData.longitude,
      });
      setSearchQuery(formData.address || "");
      return;
    }
  }, [isOpen, apiKey]);

  useEffect(() => {
    if (!isOpen) return;
    if (!formData.address) return;
    if (formData.latitude && formData.longitude) {
      setSelectedLocation({
        lat: formData.latitude,
        lng: formData.longitude,
      });
      setSearchQuery(formData.address || "");
      setAddressId(formData.address_id || null);
    }
  }, [isOpen]);

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);
  const handlePlaceSearch = useCallback((query) => {
    if (!query.trim()) return setSearchResults([]);

    if (!placesServiceRef.current) {
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        document.createElement("div"),
      );
    }
    placesServiceRef.current.textSearch(
      { query, fields: ["name", "geometry", "formatted_address"] },
      (results, status) => {
        if (status === "OK") setSearchResults(results);
        else setSearchResults([]);
      },
    );
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => handlePlaceSearch(value), 300);
  };
  const handleResultClick = (result) => {
    const loc = result.geometry.location.toJSON();
    setSelectedLocation(loc);

    const updated = {
      ...formData,
      address: result.formatted_address,
      latitude: loc.lat,
      longitude: loc.lng,
    };

    setFormData(updated);

    dispatch(
      updateTempForm({
        booking_id: formData.booking_id,
        data: {
          address: updated.address,
          latitude: updated.latitude,
          longitude: updated.longitude,
        },
      }),
    );

    setSearchQuery(result.formatted_address);
    setSearchResults([]);
  };

  const handleMapClick = (e) => {
    const loc = e.latLng.toJSON();
    setSelectedLocation(loc);

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${loc.lat},${loc.lng}&key=${apiKey}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const addr = data.results[0]?.formatted_address || "";

        setFormData({
          ...formData,
          address: addr,
          latitude: loc.lat,
          longitude: loc.lng,
        });

        dispatch(
          updateTempForm({
            booking_id: formData.booking_id,
            data: { address: addr, latitude: loc.lat, longitude: loc.lng },
          }),
        );

        setSearchQuery(addr);
      });
  };

  const handleSaveAddress = async () => {
    try {
      const payload = {
        address: formData.address,
        latitude: formData.latitude,
        longitude: formData.longitude,
      };
      console.log(addressId, "jhgf");
      let response;

      if (addressId) {
        response = await axiosConfig.patch(
          `/accounts/address/${addressId}/`,
          payload,
        );
      } else {
        response = await axiosConfig.post(`/accounts/address/`, payload);
      }

      const savedId = response.data.id;
      setAddressId(savedId);
      const updated = {
        ...formData,
        address_id: savedId,
        address: formData.address,
      };

      setFormData(updated);

      dispatch(
        updateTempForm({
          booking_id: formData.booking_id,
          data: {
            address_id: updated.address_id,
            address: updated.address,
            latitude: updated.latitude,
            longitude: updated.longitude,
          },
        }),
      );

      onClose();
    } catch (err) {
      console.error("❌ Error saving address:", err);
    }
  };

  return (
    <Modal centered size="lg" show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Address</Modal.Title>
      </Modal.Header>
      <div className="address-modal-container p-3">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search for a place"
          className="address-search-input"
        />
        {searchResults.length > 0 && (
          <ul className="address-list-container">
            {searchResults.map((r, i) => (
              <li key={i} onClick={() => handleResultClick(r)}>
                {r.formatted_address}
              </li>
            ))}
          </ul>
        )}
        <LoadScript googleMapsApiKey={apiKey} libraries={librariesArray}>
          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: "300px",
              borderRadius: "10px",
              overflow: "hidden",
              marginTop: "10px",
            }}
            center={selectedLocation || { lat: 17.38714, lng: 78.491684 }}
            zoom={13}
            onLoad={onMapLoad}
            onClick={handleMapClick}
          >
            {selectedLocation && (
              <Marker
                position={selectedLocation}
                icon={{
                  url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                }}
              />
            )}
          </GoogleMap>
        </LoadScript>
        <div className="row mt-3">
          <div className="col-md-6">
            <label className="address-label">Latitude</label>
            <input
              className="latlong-box"
              value={formData.latitude || ""}
              readOnly
            />
          </div>

          <div className="col-md-6">
            <label className="address-label">Longitude</label>
            <input
              className="latlong-box"
              value={formData.longitude || ""}
              readOnly
            />
          </div>
        </div>
        <label className="address-label mt-3">Current Address</label>
        <textarea
          className="current-address-box"
          rows={2}
          value={formData.address || ""}
          readOnly
        />
        <button className="address-save-btn mt-3" onClick={handleSaveAddress}>
          Save Address
        </button>
      </div>
    </Modal>
  );
};

export { AddressModal };
